export default __webpack_public_path__ + "static/media/configuration.341fc575.md";